import * as React from 'react';
import clsx from 'clsx';
import { Interactive } from '../Base';
import Svg from '../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Pill-root_3TDMD",
  "active": "Pill-active_158Df",
  "selected": "Pill-selected_2G4X6",
  "icon": "Pill-icon_1WHUe",
  "default": "Pill-default_22iwf",
  "small": "Pill-small_-N31f",
  "readOnly": "Pill-readOnly_10SIZ",
  "disabled": "Pill-disabled_3_CqL"
};
function Pill({
  as,
  to,
  href,
  icon,
  children,
  theme,
  size,
  small,
  selected,
  readOnly,
  disabled,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles.default]: !small,
    [styles.small]: small,
    [styles.selected]: selected,
    [styles.readOnly]: readOnly,
    [styles.disabled]: disabled
  }, className);
  return /*#__PURE__*/_jsxs(Interactive, {
    tagName: as,
    to: to,
    href: href,
    flexInline: true,
    flexAlignItemsCenter: true,
    gap: "spacing-2x",
    size: small ? 'small' : 'base',
    weight: "regular",
    disabled: to || href ? undefined : disabled,
    className: rootClasses,
    ...extraProps,
    children: [icon && Svg.has(icon) && /*#__PURE__*/_jsx(Svg, {
      name: icon,
      className: styles.icon
    }), children]
  });
}
export default Pill;